import { useCurrentDialog } from "@/GlobalData";
import M3textedit from "@/common/components/m3textedit";
import { useState } from "react";
import { User } from "@/common/data/User";
import M3ripple from "@/common/components/m3ripple";
import { M3InfiniteLoading } from "@/common/components/m3infiniteloading";

export function ChangeName({ oldname, modify }: { oldname: string, modify: (modifier: (draft: User) => void) => Promise<User> }) {
    const [newName, setNewName] = useState(oldname)
    const [loading, setLoading] = useState(false)
    const currentDialog = useCurrentDialog();
    const handleSubmit = async (e: unknown) => {
        // This function only runs if all HTML validations pass
        const e2 = e as FormDataEvent
        e2.preventDefault();
        setLoading(true);
        await modify((x) => {
            x.namaLengkap = newName;
        })
        setLoading(false);
        currentDialog.hideDialog()
    };
    return <div className="w-full inline-flex flex-col justify-start items-start gap-2.5 overflow-hidden">
        <div className="self-stretch justify-start text-stone-500 text-base font-normal font-['Be_Vietnam_Pro'] leading-normal">Nama digunakan disini untuk membantu identifikasi setiap orang yang menggunakan layanan ini</div>
        <div className="self-stretch flex-1 flex flex-col justify-start items-start gap-2.5 overflow-hidden">
            <form onSubmit={handleSubmit} className="w-full">
                {/* @ts-expect-error: Invalid cast */}
                <M3textedit className="w-full" placeholder={"Nama baru"} required minLength="3" value={newName} onInput={(e) => {
                    setNewName((e.target as HTMLInputElement).value);
                }} />
                {loading ? <div className="mt-2">
                    <M3InfiniteLoading />
                </div> :
                    <button className="self-stretch py-[5px] mt-2 inline-flex justify-end items-start gap-2.5 overflow-hidden" type="submit">
                        <div className="size- px-3.5 py-3 bg-neutral-100 rounded-md outline outline-1 outline-offset-[-1px] outline-teal-900 flex justify-start items-start gap-1 relative">
                            <div className="justify-start text-zinc-600 text-lg font-normal font-['Be_Vietnam_Pro']">Submit</div>
                            <M3ripple />
                        </div>
                    </button>}
            </form>
        </div>
    </div>;
}